import { schema } from 'normalizr'

import * as schemas from './individual.schema'

export const episodeTherapistSchema = new schema.Entity('episodeTherapistContainer', {
    EPTHERAPISTS: [schemas.EPTHERAPISTS],
});

 